import { Box, Button, LinearProgress, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { QUESTIONS } from '../../constants/persistentSoiling';
import { useFieldValue } from '../../hooks/useFormValues';
import type { FieldComponentProps } from '../form-engine/types';
import { RECOMMENDATIONS_ANCHOR_ID } from './PersistentSoilingRecommendations';

const PersistentSoilingProgress = ({ field }: FieldComponentProps) => {
  const answers = useFieldValue(field.name!) || {};
  const answered = QUESTIONS.filter((question) => answers[question.id]).length;

  return (
    <Grid
      size={12}
      sx={{
        position: 'sticky',
        top: 64,
        zIndex: 2,
        px: 2,
        py: 1.5,
        bgcolor: 'background.paper',
        border: 1,
        borderColor: 'divider',
        borderRadius: 1,
        boxShadow: '2px 2px 4px rgba(0, 0, 0, 0.2)',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
        <Box sx={{ flexGrow: 1 }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.75 }}>
            <Typography variant="body2" color="text.secondary">
              Questions answered
            </Typography>
            <Typography variant="body2" color="text.primary" sx={{ fontWeight: 600 }}>
              {answered} / {QUESTIONS.length}
            </Typography>
          </Box>
          <LinearProgress variant="determinate" value={(answered / QUESTIONS.length) * 100} sx={{ height: 6, borderRadius: 3 }} />
        </Box>
        <Button
          variant="outlined"
          size="small"
          sx={{ textTransform: 'none', flexShrink: 0 }}
          onClick={() => document.getElementById(RECOMMENDATIONS_ANCHOR_ID)?.scrollIntoView({ behavior: 'smooth' })}
        >
          View recommendations
        </Button>
      </Box>
    </Grid>
  );
};

export default PersistentSoilingProgress;
